// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import AsyncStorage from "@react-native-async-storage/async-storage";
const LOCAL_WEBAPP = false;
const baseUrl_LOCAL_WEBAPP = "https://localhost:7061";
const baseUrl = LOCAL_WEBAPP ? baseUrl_LOCAL_WEBAPP : "";
const pathLogin = "/api/Authentication/login";
const pathLogout = "/api/Authentication/logout";
const endPoints = {
    /* API FARMER */
    pathApiOwnStorage: "/api/Farmer/deposit/digestatoNotShared",
    pathApiNextOutgoing: "/api/farmer/transfer/nextoutgoing",
    pathApiNextIncoming: "/api/farmer/transfer/nextincoming",
    pathApiCo2Saved: "/api/farmer/co2Saved",
    pathApiDatatable1: "/api/farmer/transfer/exited",
    pathApiDatatable2: "/api/farmer/transfer/entered",
    pathApiFarmerStatistics: "/api/Farmer/transfer/statistics",
    pathApiUserDataFarmer: "/api/Farmer/profile",
    pathApiUpdateNextIncoming: "/api/Farmer/transfer/update",
    pathApiUpdateOwnStorage: "/api/Farmer/deposit/updatedigestato",
    pathApiInsertNewDigestateWithdrawl: "/api/Farmer/transfer/registerpickup",
    pathApiBathtubsLists: "/api/Farmer/deposit/forpickup",
    fetchBathtubsDataPageFilter: "/api/Farmer/deposit/fetchBathtubsDataPageFilter",
    pathApiFarmerConfig: "/api/Farmer/config",
    pathApiNewTransferRequest: "/api/Farmer/transfer/createRequest",
    pathApiRequestsList: "/api/Farmer/transfer/requests/list",
    pathApiDeleteRequest: "/api/Farmer/transfer/request/delete",
    pathApiEditRequest: "/api/Farmer/transfer/requests/edit",
    pathApiPlannedTransfer: "/api/Farmer/transfer/nextplanned",
    pathApiMaterialsHandled: "/api/Farmer/deposits/contenttypes",
    fetchBathtubsToConfirm: "/api/Farmer/deposits/fetchBathtubsToConfirm",
    fetchBathtubsDestination: "/api/Farmer/deposits/fetchBathtubsDestination",
    fetchBathtubsToWithdrawFrom: "/api/Farmer/deposit/fetchBathtubsToWithdrawFrom",

    /*END API FARMER */

    /*API SHARED DEPOSIT MANAGER */
    pathApiSharedStorage: "/api/SharedDepositManager/deposit/digestato",
    pathApiSharedStatistics: "/api/SharedDepositManager/transfer/statistics",
    /* END API SHARED DEPOSIT MANAGER */

    /* API DRIVER */
    pathApiUserDataCarrier: "/api/Driver/profile",
    pathApiTrasports: "/api/Driver/transfer/nextopen",
    pathApiVehiclesList: "/api/Driver/vehicle/list",
    pathApiTotals: "/api/Driver/transfer/statistics",
    pathStartRoute: "/api/Driver/transfer/begin",
    pathEndRoute: "/api/Driver/transfer/complete",
    pathApiDriverConfig: "/api/Driver/config",
    pathApiTransportGroupsList: "/api/Driver/transferGroup/list",
    pathApiTransportGroupsTransfers: "/api/Driver/transferGroup/transfers",
    pathApiTransferGroupSelect: "/api/Driver/transferGroup/select",
    pathApiTransferGroupDeselect: "/api/Driver/transferGroup/deselect",
    pathApiSuspendTransfer: "/api/Driver/transfergroup/suspend",
    pathApiCreateNoteTransfer: "/api/Driver/transfergroup/notes",
    /* END API DRIVER */
};

/* API FARMER (Easy)*/

/* END API FARMER (Easy)*/

const config = {
    withCredentials: true,
    baseURL: baseUrl,
    timeout: 40000,
};

const logger = require("./loggingConfig");

{
    /* HANDLING COOKIES*/
}
const axios = require("axios").default;
const { CookieJar } = require("tough-cookie");
const { wrapper } = require("axios-cookiejar-support");
const jar = new CookieJar();
config.jar = jar;
const client = wrapper(axios.create(config));

{
    /* COOKIE HANDLING END */
}

client.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response && error.response.status === 422) {
            return Promise.resolve(error);
        }
        if (error.response && error.response.status === 401) {
            await AsyncStorage.removeItem("userData");
        }
        if (error.response && error.response.status === 404) {
            await AsyncStorage.removeItem("userData");
        }
        return Promise.reject(error);
    }
);

/* SUMMARY FUNCTIONS CONFIG  */
async function fetchData(url) {
    console.log("fetchData: url = ", url)
    try {

        const response = await client.get(url, {
            headers: {
                'LANGUAGE_CODE': await AsyncStorage.getItem("preferredLanguage")
            }
        });

        return response;
    } catch (error) {
        logger.error("Error thrown in the fetching data function. (axiosConfig.js): " + error);
    }
}

async function updateData(url) {
    try {
        const response = await client.put(url, {
            headers: {
                'LANGUAGE_CODE': await AsyncStorage.getItem("preferredLanguage")
            }
        });

        return response;
    } catch (error) {
        logger.error("Error thrown in the updating data function. (axiosConfig.js): " + error);
    }
}

async function insertData(url) {
    try {
        const response = await client.post(url, {
            headers: {
                'LANGUAGE_CODE': await AsyncStorage.getItem("preferredLanguage")
            }
        });

        return response;
    } catch (error) {
        logger.error("Error thrown in the inserting data function. (axiosConfig.js): " + error);
    }
}

async function deleteData(url) {
    try {
        const response = await client.delete(url, {
            headers: {
                'LANGUAGE_CODE': await AsyncStorage.getItem("preferredLanguage")
            }
        });
        return response;
    } catch (error) {
        logger.error("Error thrown in the inserting data function. (axiosConfig.js): " + error);
    }
}

/* SUMMARY FUNCTIONS END (CONFIG) */

/* FUNCTIONS FARMER */
async function insertNewDigestateWithdrawl(date, quantity, depositId) {
    const url = `${endPoints.pathApiInsertNewDigestateWithdrawl}?date=${date}&quantity=${quantity}&depositId=${depositId}`;
    return insertData(url);
}

async function insertNewRequest(data) {
    let url;
    if (data.depositId && data.contentType == "DigestatoLiquido") {
        url = `${endPoints.pathApiNewTransferRequest}?contentType=${data.contentType}&roundTripsNumber=${data.roundTripsNumber}&toCall=${data.toCall}&isUrgent=${data.isUrgent}&depositId=${data.depositId}`;
    } else {
        url = `${endPoints.pathApiNewTransferRequest}?contentType=${data.contentType}&roundTripsNumber=${data.roundTripsNumber}&toCall=${data.toCall}&isUrgent=${data.isUrgent}`;
    }
    return insertData(url);
}

async function editRequestData(data) {
    const url = `${endPoints.pathApiEditRequest}?transferGroupId=${data.transferGroupId}&roundTripsNumber=${data.roundTripsNumber}&toCall=${data.toCall}&isUrgent=${data.isUrgent}`;
    return updateData(url);
}

async function updateNextIcoming(id, quantity) {
    const url = `${endPoints.pathApiUpdateNextIncoming}?transferid=${id}&quantity=${quantity}`;
    return updateData(url);
}

async function updateOwnStorage(id, quantity) {
    const url = `${endPoints.pathApiUpdateOwnStorage}?depositId=${id}&quantity=${quantity}`;
    return updateData(url);
}

async function fetchNextIncoming() {
    return fetchData(endPoints.pathApiNextIncoming);
}

async function fetchHandleMaterials(withAus = false) {
    return fetchData(`${endPoints.pathApiMaterialsHandled}?withAus=${withAus}`);
}

async function fetchRequestsList() {
    return fetchData(endPoints.pathApiRequestsList);
}
async function fetchNextPlannedTransfers() {
    return fetchData(endPoints.pathApiPlannedTransfer);
}


async function fetchBathtubsToWithdrawFrom(role) {
    return fetchData(`${endPoints.fetchBathtubsToWithdrawFrom}?role=${role}`)
}

async function fetchBathtubsDataPageFilter() {
    return fetchData(endPoints.fetchBathtubsDataPageFilter);
}
async function fetchBathtubsToConfirm() {
    return fetchData(`${endPoints.fetchBathtubsToConfirm}`);
}

async function fetchBathtubsDestination() {
    return fetchData(`${endPoints.fetchBathtubsDestination}`);
}


async function fetchSharedStorage() {
    return fetchData(endPoints.pathApiSharedStorage);
}

async function fetchAlertMessage() {
    return fetchData(endPoints.pathApiAlert);
}

async function fetchNextOutgoing() {
    return fetchData(endPoints.pathApiNextOutgoing);
}

async function fetchCo2Saved(dateFrom, dateTo) {
    const url = `${endPoints.pathApiCo2Saved}?from=${dateFrom}&to=${dateTo}`;
    return fetchData(url);
}

async function fetchDataTable1(dateFrom, dateTo) {
    const url = `${endPoints.pathApiDatatable1}?from=${dateFrom}&to=${dateTo}&page=0&max=100`;
    return fetchData(url);
}

async function fetchFarmerStatistics(
    dateFrom,
    dateTo,
    contentType,
    depositId,
    direction
) {
    //console.trace("fetchFarmerStatistics::contentType = ", contentType);
    let url = `${endPoints.pathApiFarmerStatistics}?`;
    if (dateFrom) {
        url += `from=${dateFrom}&`
    }
    if (dateTo) {
        url += `to=${dateTo}&`
    }

    url += `contentType=${contentType ? contentType : "Liquame"}&`

    if (depositId) {
        url += `depositId=${depositId}&`
    }

    url += `direction=${direction ? direction : "IN"}&`

    url += "page=0&max=100"

    return fetchData(url);
}

async function getFarmerConfig() {
    return fetchData(endPoints.pathApiFarmerConfig);
}
/* END FUNCTIONS FARMER */

/* FUNCTIONS DRIVER*/
async function getDriverConfig() {
    return fetchData(endPoints.pathApiDriverConfig);
}
async function fetchVechicleList(contentType) {
    let url = `${endPoints.pathApiVehiclesList}`;
    if (contentType !== undefined && contentType != null) {
        url = `${endPoints.pathApiVehiclesList}?ContentType=${contentType}`;
    }
    return fetchData(url);
}
async function fetchTransportGroupList() {
    return fetchData(endPoints.pathApiTransportGroupsList);
}
async function fetchActiveTransferGroup() {
    return fetchData(endPoints.pathApiTransportGroupsTransfers);
}

async function fetchTrasportsDriver() {
    return fetchData(endPoints.pathApiTrasports);
}

async function fetchTotalsDriver(dateFrom, dateTo) {
    const url = `${endPoints.pathApiTotals}?from=${dateFrom}&to=${dateTo}&page=0&max=100`;
    return fetchData(url);
}

async function selectTransferGroup(transferGroupId) {
    const url = `${endPoints.pathApiTransferGroupSelect}?transferGroupId=${transferGroupId}`;
    return updateData(url);
}

async function deleteRequestTransferGroup(transferGroupId) {
    const url = `${endPoints.pathApiDeleteRequest}?transferGroupId=${transferGroupId}`;
    return deleteData(url);
}

async function deselectTransferGroup(transferGroupId) {
    const url = `${endPoints.pathApiTransferGroupDeselect}?transferGroupId=${transferGroupId}`;
    return updateData(url);
}
async function suspendTransferGroup(transferGroupId, note) {
    const url = `${endPoints.pathApiSuspendTransfer}?transferGroupId=${transferGroupId}&note=${note}`;
    return updateData(url);
}

async function createNoteTransferGroup(transferGroupId, note) {
    const url = `${endPoints.pathApiCreateNoteTransfer}?transferGroupId=${transferGroupId}&note=${note}`;
    return updateData(url);
}

async function arrivedRequest(
    transferId,
    confirmedQuantity,
    confirmedDryQuantityPercentage
) {
    let url = `${endPoints.pathEndRoute}?transferId=${transferId}`;
    if (confirmedQuantity) {
        url = `${endPoints.pathEndRoute}?transferId=${transferId}&confirmedQuantity=${confirmedQuantity}`;
    }
    if (confirmedQuantity && confirmedDryQuantityPercentage) {
        url = `${endPoints.pathEndRoute}?transferId=${transferId}&confirmedQuantity=${confirmedQuantity}&dryQuantityPercentage=${confirmedDryQuantityPercentage}`;
    }
    try {
        const response = await client.put(url);
        return response;
    } catch (error) {
        throw error;
    }
}

async function confirmOwnStorageRequest(transferId) {
    let url = `${endPoints.pathConfirmQuantity}?transferId=${transferId}`;
    try {
        const response = await client.put(url);
        return response;
    } catch (error) {
        throw error;
    }
}

async function startRequest(transferId, quantity, vehicleId) {
    const url = `${endPoints.pathStartRoute}?transferId=${transferId}&vehicleId=${vehicleId}&loadedQuantity=${quantity}`;
    try {
        const response = await client.put(url);
        return response;
    } catch (error) {
        throw error;
    }
}
/* END FUNCTIONS DRIVER */

/*  FUNCTIONS SHARED DEPOSIT MANAGER*/
async function fetchSharedDataTable1(dateFrom, dateTo) {
    const url = `${endPoints.pathApiSharedDatatable1}?from=${dateFrom}&to=${dateTo}&page=0&max=100`;
    return fetchData(url);
}

async function fetchSharedStatistics(
    dateFrom,
    dateTo,
    contentType = "Letame",
    depositId,
    direction = "IN"
) {
    let url;
    if (depositId) {
        url = `${endPoints.pathApiSharedStatistics}?from=${dateFrom}&to=${dateTo}&contentType=${contentType}&depositId=${depositId}&direction=${direction}&page=0&max=100`;
    } else {
        url = `${endPoints.pathApiSharedStatistics}?from=${dateFrom}&to=${dateTo}&contentType=${contentType}&page=0&max=100`;
    }
    return fetchData(url);
}

async function fetchSharedDataTable2(dateFrom, dateTo) {
    const url = `${endPoints.pathApiSharedDatatable2}?from=${dateFrom}&to=${dateTo}&page=0&max=100`;
    return fetchData(url);
}

async function fetchTotalCo2Saved() {
    return fetchData(endPoints.fetchTotalCo2Saved);
}
/* END FUNCTION SHARED DEPOSIT MANAGER */

/* COMMMON FUNCTION */
async function fetchUserData(role) {
    if (role == "Farmer") {
        let FarmerData = await fetchData(endPoints.pathApiUserDataFarmer);
        if (FarmerData.status == 200) {
            return FarmerData;
        }
    } else {
        let CarrierData = await fetchData(endPoints.pathApiUserDataCarrier);
        if (CarrierData.status == 200) {
            return CarrierData;
        }
    }
    return null;
}

async function LogoutRequest() {
    try {
        const response = await client.post(pathLogout);
        return response;
    } catch (error) {
        throw error;
    }
}

async function authenticationRequest(logindata) {
    try {
        const response = await client.post(pathLogin, logindata);
        return response;
    } catch (error) {
        throw error;
    }
}

/* END COMMON FUNCTIONS */

export {
    fetchNextIncoming,
    authenticationRequest,
    fetchNextOutgoing,
    fetchCo2Saved,
    fetchDataTable1,
    fetchFarmerStatistics,
    fetchTrasportsDriver,
    fetchUserData,
    updateNextIcoming,
    insertNewDigestateWithdrawl,
    updateOwnStorage,
    fetchVechicleList,
    LogoutRequest,
    arrivedRequest,
    startRequest,
    fetchTotalsDriver,
    editRequestData,
    fetchNextPlannedTransfers,
    fetchBathtubsToConfirm,
    fetchBathtubsDestination,
    fetchAlertMessage,
    fetchSharedDataTable1,
    fetchSharedDataTable2,
    fetchTotalCo2Saved,
    fetchSharedStorage,
    confirmOwnStorageRequest,
    fetchTransportGroupList,
    getDriverConfig,
    fetchActiveTransferGroup,
    getFarmerConfig,
    fetchRequestsList,
    deselectTransferGroup,
    selectTransferGroup,
    insertNewRequest,
    deleteRequestTransferGroup,
    createNoteTransferGroup,
    suspendTransferGroup,
    fetchHandleMaterials,
    fetchSharedStatistics,
    fetchBathtubsDataPageFilter,
    fetchBathtubsToWithdrawFrom,
};
